import { LOG_IN, LOG_OUT, ME, UPDATE } from './actionTypes';
import { add, clear } from '../../utils/localStorage';
import axios from '../../utils/axios';
import { hideSnackbar, showSnackbar } from '../snackbar';

const logIn = (username, password) => (dispatch) => {
  dispatch({ type: `${LOG_IN}_REQUEST` });
  axios.post('users/sign_in', { user: { username, password } })
    .then((response) => {
      const credentials = {
        token: response.headers['access-token'],
        uid: response.headers.uid,
        client: response.headers.client,
      };
      const user = response.data.user;
      add('user', user);
      add('credentials', credentials);
      dispatch({ type: `${LOG_IN}_SUCCESS`, user });
    })
    .catch(error => dispatch({ type: `${LOG_IN}_ERROR`, error }));
};

const logOut = () => (dispatch) => {
  dispatch({ type: `${LOG_OUT}_REQUEST` });
  axios.delete('users/sign_out', { data: {} })
    .then(() => {
      clear();
      dispatch({ type: `${LOG_OUT}_SUCCESS` });
    })
    .catch(error => dispatch({ type: `${LOG_OUT}_ERROR`, error }));
};

const me = () => (dispatch) => {
  dispatch({ type: `${ME}_REQUEST` });
  axios.get('employee/me', { data: {} })
    .then(response => dispatch({ type: `${ME}_SUCCESS`, user: response.data.employee }))
    .catch(error => dispatch({ type: `${ME}_ERROR`, error }));
};

const update = user => (dispatch) => {
  dispatch({ type: `${UPDATE}_REQUEST` });
  dispatch(hideSnackbar());
  axios.put('employee/me', user)
    .then(() => {
      dispatch(showSnackbar('Tu usuario fue actualizado correctamente.', 'success'));
      dispatch({ type: `${UPDATE}_SUCCESS` });
      dispatch(me());
    })
    .catch((error) => {
      dispatch(showSnackbar('Ha ocurrido un error al actualizar el tu usuario.', 'error'));
      dispatch({ type: `${UPDATE}_ERROR`, error });
    });
};

export {
  me,
  logIn,
  logOut,
  update,
};



// WEBPACK FOOTER //
// ./src/actions/user/index.js